import { IRootScopeService } from "angular";
import { StateService } from "@uirouter/angularjs";
import { UserService } from "../userService";
import { UIErrorHandlingService } from "@gtmhub/error-handling";
import { IAvatarScope } from "../userProfile/controllers/avatar.ctrl";
import { IPatchedUser, IUser } from "../models";
import { ITraceRootScopeService } from "@gtmhub/core/tracing";
import { IModalService, IModalServiceInstance } from "angular-ui-bootstrap";

export interface IChangeUserAvatarStateParams {
  id: string;
  employeeId: string;
}

export class ChangeUserAvatarCtrl {
  private user: IUser;

  public static $inject = ["$uibModal", "$rootScope", "$scope", "$stateParams", "UserService", "UIErrorHandlingService", "$state"];

  constructor(
    private $uibModal: IModalService,
    private $rootScope: IRootScopeService & ITraceRootScopeService,
    private $scope: IAvatarScope,
    private $stateParams: IChangeUserAvatarStateParams,
    private userService: UserService,
    private uiErrorHandlingService: UIErrorHandlingService,
    private $stateService: StateService
  ) {
    this.$scope.upload = this.upload;
    this.$scope.remove = this.remove;
    this.$scope.restore = this.restore;
    this.$scope.indicators = {};
    this.init();
  }

  private init = (): void => {
    this.$scope.indicators.loading = true;

    const userId = this.$stateParams.employeeId || this.$stateParams.id;
    this.userService.getUser(userId).then(
      (user) => {
        this.$scope.indicators.loading = false;
        this.user = user;
        this.$scope.profile = {
          email: user.email,
          firstName: user.firstName,
          lastName: user.lastName,
          avatar: user.avatar,
          picture: user.picture,
          created: user.dateCreated,
          language: user.language,
          pictureInfo: user.pictureInfo,
        };
      },
      (err) => this.uiErrorHandlingService.handleIndicator(err, { indicator: "loading" })
    );
  };

  private restore = () => {
    const patchedUser: IPatchedUser = {
      restoreUserPicture: true,
    };

    this.$scope.indicators.uploading = true;

    this.userService.patchUser(this.user.id, patchedUser).then(
      () => {
        this.$scope.indicators.uploading = false;
        this.$rootScope.$broadcast("usersChanged", false);
        if (this.$stateService.current.name.includes("employees")) {
          this.$rootScope.$broadcast("employeeChanged");
          this.$rootScope.$broadcast("employeesChanged");
        }
        this.$scope.$close();
      },
      (err) => {
        this.$scope.indicators.uploading = false;
        this.uiErrorHandlingService.handleModal(err);
      }
    );
  };

  changeUserPicture = (): IModalServiceInstance => {
    return this.$uibModal.open({
      templateUrl: require("@gtmhub/users/userProfile/views/avatar.jade"),
      controller: "ChangeUserAvatarCtrl",
      windowClass: "modal modal-small vertical-center",
      backdropClass: "dark-backdrop",
    });
  };

  private remove = () => {
    this.$scope.picFile = null;
    this.$scope.croppedDataUrl = "";
  };

  private upload = (): void => {
    if (!this.$scope.croppedDataUrl) {
      return;
    }
    this.$rootScope.traceAction("upload_user_avatar", () => {
      this.$scope.indicators.uploading = true;

      this.userService.uploadAvatar(this.user, this.$scope.croppedDataUrl).then(
        (url) => {
          this.$scope.indicators.uploading = false;
          this.$scope.uploadedFileUrl = url;
          this.$rootScope.$broadcast("usersChanged", false);
          if (this.$stateService.current.name.includes("employees")) {
            this.$rootScope.$broadcast("employeeChanged");
            this.$rootScope.$broadcast("employeesChanged");
          }
          this.$scope.$close();
        },
        (err) => {
          this.$scope.indicators.uploading = false;
          this.uiErrorHandlingService.handleModal(err);
        }
      );
    });
  };
}
